import { makeApiCall } from '../../services/api'

export async function fetchUserInputs(UUID: string) {
  return makeApiCall(`/ooo-reimbursement/${UUID}`, 'GET')
}
